import React from 'react';
import './App.css';
import ConferenceScreen from './components/ConferenceScreen';
import PresenterWindow from './components/PresenterWindow';
import LoginScreen from './components/LoginScreen';
import AuthCallback from './components/AuthCallback';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { UserDataProvider } from './contexts/UserDataContext';
import { isPresenterRoute } from './lib/conferenceStore';

const isAuthCallback = () =>
  typeof window !== 'undefined' && window.location.hash?.includes('session_id=');

const GatedApp = () => {
  const { user, loading } = useAuth();

  if (isAuthCallback()) {
    return <AuthCallback />;
  }

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#0a1628',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#94a3b8',
          fontFamily: 'Inter, sans-serif',
          fontSize: 13,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
        }}
        data-testid="auth-loading"
      >
        Loading…
      </div>
    );
  }

  if (!user) {
    return <LoginScreen />;
  }

  return (
    <UserDataProvider>
      <ConferenceScreen />
    </UserDataProvider>
  );
};

function App() {
  if (isPresenterRoute()) {
    return (
      <div className="App App--presenter">
        <PresenterWindow />
      </div>
    );
  }

  return (
    <AuthProvider>
      <div className="App">
        <GatedApp />
      </div>
    </AuthProvider>
  );
}

export default App;